/**
 * segmented-switch — 索引計算（**純函數**；Node 可直接 import → `scripts/ui-smoke.mjs` 真測）
 *
 * 為何要：鍵盤 ←／→ 喺選項之間行，最易出現「行出界」或「循環到去另一個極端」嘅 bug。
 *   ⚠️ 刻意**唔循環**（← 到頭就停、→ 到尾就停）：模式切換唔應該「撳多一下就變咗另一個極端」。
 */
export function nextIndex(length: number, current: number, delta: number): number {
  if (length <= 0) return -1;
  const bounded = Number.isFinite(current) ? Math.min(Math.max(current, 0), length - 1) : 0;
  return Math.min(Math.max(bounded + delta, 0), length - 1);
}
